import PublicProfileForm from "@/components/formateur/PublicProfileForm";

export default function ProfilPublicEditPage() {
    return (
        <div className="mx-auto max-w-4xl px-6 py-10" data-testid="page-formateur-profil-public">
            <div className="mb-8">
                <h1 className="font-display text-3xl text-brand-ink md:text-4xl">Mon profil public</h1>
                <p className="mt-2 text-sm text-brand-ink/70">
                    Ces informations s'affichent sur les pages de formations et de cursus où vous intervenez.
                </p>
            </div>
            <div className="rounded-3xl border border-brand-line bg-white p-6 shadow-premium md:p-10">
                <PublicProfileForm mode="edit" onSubmitted={() => {}} />
            </div>
        </div>
    );
}
